// src/pages/CourseTime/components/slides/layouts/LongTextSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import SlideTitleSpoken from '../common/SlideTitleSpoken.comp';
import { useSlideContentRenderer } from '../../../hooks/useSlideContentRenderer';

// Layout: TemplateLongText
const LongTextSlide = ({ slide, renderSpokenText, skipTitleSpeech }) => {
  const { renderContent } = useSlideContentRenderer({ renderSpokenText, skipTitleSpeech });

  return (
    <S.SlideDescription>
      <S.SlideTitle>
        <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
      </S.SlideTitle>
      <S.PointText>{renderContent('content_0', slide.SlideContent)}</S.PointText>
    </S.SlideDescription>
  );
};

export default LongTextSlide;
